import React from "react";
import {
  Code2,
  Server,
  Factory,
  ShoppingBag,
  Store,
  Stethoscope,
  Workflow,
  Truck,
  Rocket,
} from "lucide-react";

const INDUSTRIES = [
  { icon: Code2, label: "IT" },
  { icon: Server, label: "SaaS" },
  { icon: Factory, label: "Manufacturing" },
  { icon: ShoppingBag, label: "D2C" },
  { icon: Store, label: "Retail" },
  { icon: Stethoscope, label: "Healthcare" },
  { icon: Workflow, label: "Operations" },
  { icon: Truck, label: "Logistics" },
  { icon: Rocket, label: "Startups" },
];

export default function IndustriesServe() {
  return (
    <section
      id="industries"
      className="py-16 md:py-20"
      data-testid="industries-section"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="uppercase text-xs tracking-[0.22em] font-bold text-brand-primary">
            Industries We Serve
          </span>
          <h3 className="mt-3 font-heading font-medium text-2xl sm:text-3xl tracking-tight">
            Hiring across sectors — wherever your team is growing.
          </h3>
        </div>

        <div className="mt-10 grid grid-cols-3 sm:grid-cols-3 md:grid-cols-5 lg:grid-cols-9 gap-3 md:gap-4">
          {INDUSTRIES.map(({ icon: Icon, label }, i) => (
            <div
              key={label}
              className="flex flex-col items-center justify-center gap-2 rounded-2xl bg-white border border-brand-border px-3 py-5 hover:border-brand-primary/40 hover:shadow-sm transition-all"
              data-testid={`industry-${i}`}
            >
              <div className="w-10 h-10 rounded-xl bg-brand-soft grid place-items-center text-brand-primary">
                <Icon size={18} />
              </div>
              <div className="text-xs sm:text-sm font-medium text-brand-ink text-center">
                {label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
